// eslint-disable-next-line no-restricted-imports
import {Flex, Text, Box} from '@chakra-ui/react';
import {
  ShowpieceCard,
  ShowpieceCardProps,
} from '../showpiece-card/showpiece-card';

interface FeaturedProductsBannerProps {
  items: ShowpieceCardProps[];
  heading?: string;
}

export const FeaturedProductsBanner: React.FC<FeaturedProductsBannerProps> = ({
  heading,
  items,
}) => {
  return (
    <Box
      maxW="container.xl"
      w="100%"
      m="0 auto"
      px={{base: '12px', md: '24px'}}
    >
      {heading && (
        <Text
          as="h2"
          textStyle={{base: 'h5', md: 'h4'}}
          color="charcoal"
          mt={{base: '100px', md: '120px'}}
          mb={{base: '40px', md: '56px'}}
          textAlign="center"
        >
          {heading}
        </Text>
      )}
      <Flex
        alignItems={{base: 'center', md: 'stretch'}}
        justifyContent="center"
        flexDir={{base: 'column', md: 'row'}}
      >
        {items &&
          items.map((card: ShowpieceCardProps) => (
            <Box
              px={{base: 4, sm: 4}}
              width="100%"
              maxW="426px"
              key={card.assetId}
              mt={4}
            >
              <ShowpieceCard {...card} />
            </Box>
          ))}
      </Flex>
    </Box>
  );
};
